import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ExceluploadService {
  apiUrl: string;
  constructor(private _http: HttpClient) {
    this.apiUrl = 'https://mktgcost.iffco.coop/api/Excelupload/';
  }

  getdatadown(Year: string) {
    debugger;
    var params = new HttpParams().set('Year', Year);
    return this._http.get(this.apiUrl + 'Getdata', { params: params }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }
  SaveData(tableData: any) {
    debugger;
    let header = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.post<any>(this.apiUrl + 'SaveData', tableData, { headers: header }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }

}
